// extracted by mini-css-extract-plugin
export default {"container":"e4-z","title":"f4-z","link":"g4-z"};